<template>
  <div>
    <h2 :class="['headline', 'font-grey', 'font-l-600']" v-html="title" />
    <div :class="['server-side-description']" v-html="description" />
    <vc-layout :spacing="8">
      <vc-col :span="6" v-for="(browser, index) in browsers" :key="index" sm12 md8>
        <vc-card :class="['elevation-6']">
          <vc-card-media height="64px" :class="['align-center', 'pa-8']">
            <vc-icon :color="browser.color" size="x-large">{{ browser.icon }}</vc-icon>
          </vc-card-media>
          <vc-card-title :class="['pa-8']" :dark="false" :color="browser.color">
            <h2 is="span" :class="['body-2', 'vc-block', 'align-center']" v-html="browser.name.toUpperCase()" />
          </vc-card-title>
        </vc-card>
      </vc-col>
    </vc-layout>
    <example-title title="Enable IE11 and Safari 9 support" />
    <p>Internet Explorer 11 and Safari 9 are supported via <code>babel-polyfill</code>. In order to use it, install
      <code>babel-polyfill</code> and import it in your main entry file:</p>
    <div :class="['my-16']">
      <code>
        <span :class="['font-grey']">// your-project/</span><br />
        $ npm install babel-polyfill --save
      </code>
    </div>
    <p>And then:</p>
    <div :class="['my-16']">
      <code>
        <span :class="['font-grey']">// your-project/src/index.js</span><br />
        import 'babel-polyfill'<br />
        <span :class="['font-grey']">...</span><br />
        new Vue()
      </code>
    </div>
    <p>More information about <code>babel-polyfill</code> is available on
      its <a href="https://babeljs.io/docs/usage/polyfill/" target="_blank">official page</a>.</p>
  </div>
</template>
<script>
import methods from '../helpers/methods'

export default {
  name: 'BrowserSupportPage',
  mixins: [
    methods
  ],
  data () {
    return {
      title: null,
      description: null,
      browsers: []
    }
  },
  mounted () {
    this.$root.$emit(this.$store.state.events.ajaxStart)
    this.$http('/static/data/browsers.json').then(response => {
      this.browsers = response.data.browsers
      this.getPage()
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/browser-support.vue